<template>
  <div id="location">
    <div>오시는 길 안내</div>
    <div>
      <div id="map" v-if="isMobile"></div>
      <div class="location_cont">
        <div class="marker">서울시 구로구 개봉로 23길 10</div>
        <div class="phone">02-6737-7448~50</div>
        <div class="transportation">
          <span>시내버스</span>
          <span>
            •지선버스(초록): 5012, 5626, 6640A, 6637, 6638<br>
            •간선버스(파랑): 643, 651, 653, 652, N61<br>
            •마을버스: 구로01, 구로02, 구로05
          </span>
        </div>
        <div class="transportation">
          <span>지하철</span>
          <span>
            •1호선 개봉역 2출구 300m 직진 고가도로 밑 횡단보도 건너 센트레빌 레우스 후문 개봉소공인드림창작소 402호
          </span>
        </div>
      </div>
      <div id="map" v-if="!isMobile"></div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'

export default {
  data () {
    return {
      isMobile: common.detectMobile()
    }
  },
  mounted () {
    if (!window.kakao || !window.kakao.maps) {
      let script = document.createElement('script')
      script.src = '//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=15762d95a727b00540f2426c41f866b3&libraries=services'
      /* globals kakao */
      script.addEventListener('load', () => {
        console.log('kakao loaded', window.kakao)
        kakao.maps.load(this.initMap)
      })
      document.head.appendChild(script)
    } else {
      console.log('kakao has already loaded', window.kakao)
      this.initMap()
    }
  },
  methods: {
    initMap () {
      let marker = new kakao.maps.Marker({
        map: new kakao.maps.Map(document.getElementById('map'), {
          center: new kakao.maps.LatLng(37.495617, 126.856953),
          level: 3
        }),
        position: new kakao.maps.LatLng(37.4962273, 126.8559496)
      })
      console.log(marker)
    }
  }
}
</script>

<style scoped>
#location {
  display: flex;
  flex-direction: column;
  width: 1140px;
  margin: auto;
}

.mobile_wrap #location {
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
}

#location > div:nth-child(1) {
  margin-top: 55px;
  color: #0F1015;
  font-size: 38px;
  font-weight: 700;
  text-align: left;
}

.mobile_wrap #location > div:nth-child(1) {
  margin-top: 40px;
  font-size: 18px;
}

#location > div:nth-child(2) {
  display: flex;
  margin: 70px 0 190px;
  gap: 30px;
}

.mobile_wrap #location > div:nth-child(2) {
  display: flex;
  flex-direction: column;
  margin: 27px 0 65px;
  gap: 40px;
}

#location > div > .location_cont {
  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: left;
}

.location_cont > div {
  padding-left: 40px;
  color: #1F1F1F;
  font-size: 16px;
  font-weight: 500;
  line-height: 27px;
  letter-spacing: 0.7px;
}

.mobile_wrap .location_cont > div {
  font-size: 14px;
}

.location_cont > .marker {
  background: url('../../assets/intro/ic_marker.svg') 0 0 no-repeat;
  font-size: 18px;
  line-height: 29px;
}

.mobile_wrap .location_cont > .marker {
  background-size: auto 24px;
  font-size: 14px;
  line-height: 24px;
}

.location_cont > .phone {
  background: url('../../assets/intro/ic_phone.svg') 0 0 no-repeat;
}

.mobile_wrap .location_cont > .phone {
  background-size: auto 24px;
  font-size: 14px;
  line-height: 24px;
}

.location_cont > .transportation {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

#map {
  flex-shrink: 0;
  width: 650px;
  height: 360px;
}

.mobile_wrap #map {
  flex-shrink: 0;
  width: 100%;
  height: 360px;
}
</style>



// WEBPACK FOOTER //
// src/components/intro/Location.vue